import React from "react";
import { UserManagementViewWrap } from "./UserManagementViewWrap";

const UsersReactView = () => {
  return <UserManagementViewWrap />;
};

window.UsersReactView = UsersReactView;
